module.exports = __webpack_public_path__ + "static/media/OfficinaSansITCPro-Bold.27e01815.woff";